import React from 'react';
export function Navbar() {
  return <nav className="fixed top-9 left-0 right-0 z-40 bg-navy/95 backdrop-blur-sm border-b border-gold/10 py-4 px-5" data-id="element-98">
      <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-99">
        <div className="flex items-center" data-id="element-100">
          <img src="https://cdn.magicpatterns.com/uploads/vDghdBvUf4PnNXoRnxTGAL/logo.jpg" alt="Sales Training BUE" className="h-10 w-auto rounded-sm" data-id="element-101" />
        </div>
        <a href="#oferta" className="text-gold font-dmsans font-bold text-sm md:text-base hover:text-cream transition-colors flex items-center gap-2" data-id="element-102"></a>
      </div>
    </nav>;
}